// tslint:disable: interface-over-type-literal
export interface IContractor {
  id: number;
  name: string;
  slug: string;
  site: string;
  file_id?: any;
  company_type_id: number;
  created_at: string;
  updated_at: string;
  company_type: ICompanyType;
  representatives: IEmployee[];
  bank_attributes?: IBankAttribute[];
}
export interface ITableParam {
  params?: object;
}
export interface ICompany {
  id: number;
  name: string;
  company_type_id: number;
  created_at: string;
  updated_at: string;
  company_type: ICompanyType;
}

export interface IProposalStatus {
  id: number;
  name: string;
  color: string;
}
export interface IEmployee {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  middle_name: string;
  password: string;
  email_verified_at: string;
  role_id: number;
  created_at: string;
  position_id: number;
  position: IPosition;
  updated_at: string;
}

export interface ICompanyType {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface INotification {
  id: number;
  addressee_id: number;
  text: string;
  link: string;
  created_at: string;
  updated_at: string;
}

export interface IRole {
  id: number;
  modules: Array<{
    id: number;
    title: string;
    name: string;
    access: string;
  }>;
}

export interface IUser {
  id: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  email: string;
  email_verified_at: string;
  role_id: number;
  created_at: string;
  updated_at: string;
  notifications: INotification[];
  role: IRole;
}

export type Maybe<T> = T | null | undefined;

export interface IPageParams {
  current_page: number;
  first_page_url: string;
  from?: any;
  last_page: number;
  last_page_url: string;
  next_page_url?: any;
  path: string;
  per_page: number;
  prev_page_url?: any;
  to?: any;
  total: number;
}

export interface ITableOptions {
  page: number;
  itemsPerPage: number;
  sortBy: number[];
  sortDesc: number[];
  groupBy: number[];
  groupDesc: number[];
  mustSort: boolean;
  multiSort: boolean;
}

export interface ICRUDResponse<T> extends IPageParams {
  data: T;
}

export interface ICompanyType {
  id: number;
  name: string;
}

export interface IProposal {
  id: number;
  name: string;
  link: string;
  decision_date: string;
  description: string;
  creator_id: number;
  documents: IDocument[];
  read: boolean;
  proposal_id?: any;
  proposal_status_id: number;
  chat?: {
    id: number;
    messages: object[];
  };
  company_id: number;
  company?: ICompany;
  contractor_id: number;
  representatives: IEmployee[];
  responsible_id: number;
  created_at: string;
  updated_at: string;
}

export interface IAgreement {
  id: number;
  number: string;
  documents: IDocument[];
  date_of_conclusion: string;
  chat?: {
    id: number;
    messages: object[];
  };
  creator_id: number;
  project_id: number;
  project?: IProject;
  responsible_id: number;
  name: string;
}
export interface IAgreementStatus {
  id: number;
  name: string;
}

export interface IAgreementType {
  id: number;
  name: string;
}

export interface IUserRole {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}
export interface IUserType {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}
export interface IRepresentative {
  id: number;
  first_name: string;
  contractor_id?: number;
  middle_name: string;
  last_name: string;
  phone: string;
  email: string;
}
export interface ISystemUserRole {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface IProject {
  id: number;
  project_labor_types: IProjectLaborType[];
  name: string;
  responsible: IEmployee;
  responsible_id: number;
  budget: string;
  start_at: string;
  end_at: string;
  agreements: IAgreement[];
}

export interface IProjectLaborType {
  id: number;
  title: string;
  measure: string;
}

export interface IDepartment {
  id: number;
  name: string;
}

export interface IPosition {
  id: number;
  name: string;
  department_id: number;
  department: IDepartment;
}

export interface ILabor {
  id?: number;
  date: string;
  project_id: number;
  project?: IProject;
  project_labor_type_id: number;
  project_labor_type?: IProjectLaborType;
  user_id: number;
  value: number;
}

export interface IBankAttribute {
  id: number;
  name: string;
  value?: string;
  pivot: {
    value: string;
  };
}

export interface IPayment {
  id: number;
  actual_date: string;
  actual_price: string;
  planned_date: string;
  planned_price: string;
  description: string;
  payment_status_id: number;
  paymentable_id: number;
  paymentable_type: string;
}

export interface IPaymentable {
  name: string;
  value: string;
  url: string;
}

export interface IDocument {
  id: number;
  name: string;
  creator_id: number;
  documentable_id: number;
  documentable_type: string;
  files: IFileWrapper[];
}

export interface IFile {
  id: number;
  path: string;
  preview_path: string;
  name: string;
  extension: string;
  creator_id: number;
}

export interface IFileWrapper extends File {
  id: number;
  path?: string;
  apiRepresentation?: { path?: string };
  file?: File;
  creator_id?: number;
}

export const enum Access {
  Create = 'c',
  Read = 'r',
  Update = 'u',
  Delete = 'd',
}

export type IModule = {
  id: number;
  name: string;
  title: string;
};
